import styled, { css } from 'styled-components';

import { StyledProps } from '@/shared/lib/interfaces/styled-props.interface';
import { Icon } from '@/shared/ui/icon';

import { StyledDisabled, StyledPaginationWrapper } from './pagination.types';

export const Wrapper = styled.ul<StyledPaginationWrapper>`
	display: flex;
	align-items: center;
	padding: 0;
	margin: 0;

	${({ hasRowsPerPage }) =>
		hasRowsPerPage &&
		css`
			> :first-child {
				margin: 0 12px 0 0;
			}

			> :last-child {
				margin: 0 0 0 12px;
			}
		`}

	@media ${({ theme: { media } }) => media.mobile} {
		flex-wrap: wrap;
		row-gap: 12px;
	}
`;

export const Number = styled.li<StyledProps>`
	cursor: pointer;
	padding: 4px 12px;
	border-radius: 2px;
	background-color: ${({ active, theme: { pagination } }) =>
		active ? pagination.active.background : pagination.background};
	color: ${({ active, theme: { pagination } }) => (active ? pagination.active.color : pagination.color)};
`;

export const Arrow = styled(Icon)<StyledDisabled>`
	cursor: pointer;
	margin: 0px 12px;
	fill: ${({ theme: { pagination } }) => pagination.color};

	${({ disabled }) =>
		disabled &&
		css`
			opacity: 0.7;
			pointer-events: none;
		`}
`;
